module.exports = __webpack_public_path__ + "img/cases-brand-avic-5.a019d339.jpg";